import React from 'react';
import { useData } from '../contexts/DataContext';

/**
 * Component to display WebSocket connection status
 */
export const WebSocketStatus: React.FC = () => {
  const { websocketConnected } = useData();

  return (
    <div className="flex items-center space-x-2 text-sm">
      <div
        className={`w-2 h-2 rounded-full ${
          websocketConnected ? 'bg-green-500' : 'bg-red-500'
        }`}
        title={websocketConnected ? 'Real-time updates connected' : 'Real-time updates disconnected'}
      />
      <span className={`text-xs ${
        websocketConnected ? 'text-green-600' : 'text-red-600'
      }`}>
        {websocketConnected ? 'Live' : 'Offline'}
      </span>
    </div>
  );
};

export default WebSocketStatus;
